<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="TruckEdit"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("truckAccessEdit") }}
                  </h6>
                  <button
                    class="btn btn-default float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>

                <div class="card-body">
                  <!--begin::loading-data-->

                  <!--end::loading-data-->
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>
                    <div class="card">
                      <div class="row mx-4 my-4">
                        <div class="col-sm-6">
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("vehicle_no") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <v-select :options="fetchTruck" @search="asyncLoadTruck" @input="changeTruck" 
                              disabled v-model="selectedTruck" label="vehicle_no" return-object
                              :required="!selectedTruck.length"></v-select>
                              <div v-if="errors.vehicle_no">
                                <div
                                  v-for="error in errors.vehicle_no"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("truck_type") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="truck_type"
                                :placeholder="$t('truck_type')"
                                v-model="forms.truck_type"
                                required
                              />
                              <div v-if="errors.truck_type">
                                <div
                                  v-for="error in errors.truck_type"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("truck_brand") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="merk"
                                :placeholder="$t('truck_brand')"
                                v-model="forms.merk"
                                required
                              />
                              <div v-if="errors.merk">
                                <div
                                  v-for="error in errors.merk"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("branch_id") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="branch"
                                :placeholder="$t('branch_id')"
                                v-model="forms.branch"
                                required
                              />
                              <div v-if="errors.branch">
                                <div
                                  v-for="error in errors.branch"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("driver_id") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <!-- <input
                                type="text"
                                disabled
                                class="form-control"
                                id="driver_id"
                                :placeholder="$t('driver_id')"
                                v-model="forms.driver_id"
                                required
                              /> -->
                              <v-select :options="fetchDriver" @search="asyncLoadDriver" @input="changeDriver" v-model="selectedDriver" label="driver_id" return-object
                              :required="!selectedDriver.length">
                              <template slot="option" slot-scope="option">
                                    {{ option.driver_id }} - {{ option.driver_name }}
                            </template>
                              </v-select>
                              <div v-if="errors.driver_id">
                                <div
                                  v-for="error in errors.driver_id"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("driver_name") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="driver_name"
                                :placeholder="$t('driver_name')"
                                v-model="forms.driver_name"
                                required
                              />
                              <div v-if="errors.driver_name">
                                <div
                                  v-for="error in errors.driver_name"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("sim") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="text"
                                disabled
                                class="form-control"
                                id="sim"
                                :placeholder="$t('sim')"
                                v-model="forms.sim"
                                required
                              />
                              <div v-if="errors.sim">
                                <div
                                  v-for="error in errors.sim"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-lg-4">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                              >
                                {{ $t("startDate") }}</label
                              >
                            </div>
                            <div class="col-lg-8">
                              <Datepicker
                                v-model="forms.start_date"
                                :bootstrap-styling="true"
                                :format="'dd-MM-yyyy'"
                                placeholder="Please Select date.."
                              ></Datepicker>
                              <div v-if="errors.start_date">
                                <div
                                  v-for="error in errors.start_date"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer">
                        <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                        <button
                          v-if="!isLoading"
                          class="btn btn-primary float-end btn-sm"
                          type="submit"
                        >
                          <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>

                        <div v-if="isLoading" class="d-flex align-items-center">
                          <div
                            class="spinner-border ms-auto"
                            role="status"
                            aria-hidden="true"
                          ></div>
                          <strong>{{ $t("loadingTxt") }}...</strong>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-sm-12">
                        <div class="row my-3">
                          <div class="col-sm-12">
                            <h6 class="mb-0 card-title float-start">HISTORY PERUBAHAN BATANGAN</h6>
                            &nbsp;&nbsp;&nbsp;
                            <button
                              class="btn btn-success float-end"
                              @click="downloadData"
                              type="button"
                            >
                              <i class="link-icon" data-feather="download"></i>
                              {{ $t('downloadData') }}
                            </button>
                          </div>
                        </div>
                        <div class="row">
                          <vue-good-table
                            title="list-user"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :rows="rows"
                            :columns="columns"
                          >
                          </vue-good-table>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import Datepicker from "vuejs-datepicker";
// import moment from "moment";

export default {
  name: "TruckEdit",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    Datepicker,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      permision_role: [],
      fetchBranch: [],
      branch: [],
      closeBtn: true,
      errors: [],
      fetchCompany: [],
      company: "",
      manufacture_year: "",
      purchased_year: "",
      fetchCarrier: [],
      fetchTruckBrand: [],
      fetchBillable: [],
      fetchUnitAllocation: [],
      fetchOwnersShip: [],
      fetchTypeTruck: [],
      driver: [],
      fetchTruckCategory: [],
      truck_category: "",
      truckBrand: [],
      typeTruck: [],
      billable: [],
      unitAllocation: [],
      ownersShip: [],
      userData: "",
      companyCode: "",
      forms: [],
      images: "",
      images_temporary: null,
      fetchPic: [],
      columns: [
        {
          label: "Vehicle No",
          field: "vehicle_no",
        },
        {
          label: "Truck Type",
          field: "truck_type",
        },
        {
          label: "Driver Id",
          field: "driver_id",
        },
        {
          label: "Driver Name",
          field: "driver_name",
        },
        {
          label: "Driver Status",
          field: "driver_status",
        },
        {
          label: "Start Date",
          field: "start_date",
        },
        {
          label: "Create At",
          field: "created_at",
        },
        {
          label: "Update At",
          field: "updated_at",
        },
        {
          label: "Create By",
          field: "created_by",
        },
        {
          label: "Update By",
          field: "updated_by",
        },
      ],
      rows: [],
      fetchTruck: [],
      fetchDriver: [],
      selectedTruck:[],
      selectedDriver:[],
    };
  },
  watch: {},
  methods: {
    removeImages() {
      this.$refs.images.value = "";
      this.images_temporary = null;
    },

    handleFileUpload(event) {
      this.images = event.target.files[0];
      this.images_temporary = URL.createObjectURL(this.images);
    },

    resetForm() {
      this.removeImages();
      this.forms = "";
    },

    backForm() {
      window.location.href = "/master-batangan";
    },

    customDriverLabel(option) {
      return `${option.driver_id} - ${option.driver_name}`;
    },

    loadData(id) {
      const baseURI =
        this.$settings.endPointCt + "master-batangan/detail/" + id;
      return this.$http.get(baseURI).then((response) => {
        console.log(response);
        this.forms = response.data.datas;
        this.rows = this.forms.log;
        this.selectedTruck = {
          vehicle_no:this.forms.vehicle_no
        };
        this.selectedDriver = {
          driver_id:this.forms.driver_id
        };
      });
    },
    
    downloadData(){
      const baseURI = this.$settings.endPointCt + "/master-batangan";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(
          baseURI +
            `?vehicle_no=${this.forms.vehicle_no}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MasterBatanganController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_update) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },


    submitData() {
      this.isLoading = true;
      this.fade(true);

      let formData = {
        driver_name:this.forms?.driver_name ? this.forms.driver_name : null,
        driver_id:this.forms?.driver_id ? this.forms.driver_id : null,
        branch_name:this.forms?.branch ? this.forms.branch : null,
        sim:this.forms?.sim ? this.forms.sim : null,
        start_date: this.forms.start_date ? ( 
        this.forms.start_date.length == 10
          ? this.forms.start_date
          : this.forms.start_date.toISOString().split("T")[0]) : null,
        driver_status:this.forms?.driver_status ? this.forms.driver_status : null,
      }
      console.log(formData);
      const baseURI =
        this.$settings.endPointCt +
        "master-batangan/update/" +
        this.forms.vehicle_no;
      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.isLoading = false;
          this.loading();
          if (response.data.status === 200) {
            //this.resetForm();
            this.errors = [];
            this.success(response.data.datas.messages);

            //window.history.back();
            window.location.href =
              "/master-batangan/detail/" + this.forms.vehicle_no + "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loadDriver() {
      const baseURI = this.$settings.endPointCt + `master-driver?driver_status=Active`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
      });
    },
    loadTruck() {
      const baseURI = this.$settings.endPointCt + `master-truck`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchTruck = response.data.datas.data;
      });
    },

    loadCarrier() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=carer`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCarrier = response.data.datas;
      });
    },

    asyncLoadDriver(ev) {
      const baseURI =
        this.$settings.endPointCt + `master-driver?driver_status=Active&driver_id=` + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
      });
    },
    asyncLoadTruck(ev) {
      const baseURI =
        this.$settings.endPointCt + `master-truck?vehicle_no=` + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchTruck = response.data.datas.data;
      });
    },
    changeTruck(ev){
      this.forms.vehicle_no = ev.vehicle_no;
      this.forms.truck_type = ev.type_truck;
      this.forms.merk = ev.truck_brand;
      this.forms.branch = ev.branch_name;
    },
    changeDriver(ev){
      this.forms.driver_id = ev.driver_id;
      this.forms.driver_name = ev.driver_name;
      this.forms.sim = ev.sim1_type;
      this.forms.driver_status = ev.driver_status;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    loadCBillabel() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=bunit`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchBillable = response.data.datas;
      });
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    customLabel(option) {
      // Sesuaikan label berdasarkan kombinasi code dan name
      return `${option.code} - ${option.name}`;
    },

    loadUnitAlocation() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=tralloc`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchUnitAllocation = response.data.datas;
      });
    },

    loadOwnerShip() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=trowner`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchOwnersShip = response.data.datas;
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    loadPic() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=mstpic`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchPic = response.data.datas;
      });
    },
  },
  events: {},
  created: function () {
  },
  mounted() {
    // var params = this.$onBehind(this.$route.params.id);
    this.loadData(this.$route.params.id);
    this.fetchIt();
    this.loadDriver();
    this.loadTruck();

    // this.fetchBillable.push(
    //   {
    //     billable_id: "1",
    //     billable_name: "LOGISTIK",
    //   },
    //   {
    //     billable_id: "2",
    //     billable_name: "RENTAL",
    //   },
    // );
  },
};
</script>
<style scoped></style>
